export default {
  message: {
    common: {
      topbar: {
        toggle: 'MySpace',
        search: {
          placeholder: 'Search'
        }
      },
      sidebar: {
        title: 'MySpace'
      },
      buttons: {
        or: 'or',
        yes: 'Yes',
        no: 'No',
        preview: 'Preview',
        download: 'Download',
        viewDetails: 'View details',
        viewMore: 'View more',
        moreDetails: 'More details',
        closeDetails: 'Close details',
        register: 'Register',
        relatedDocuments: 'Related documents',
        morePastEvents: 'View more past meeting',
        changePicture: 'Change picture',
        moreUpcomingEvents: 'View more upcoming meeting',
        holidayRequest: 'Holiday request',
        travelRequest: 'Travel request',
        remoteWorkingRequest: 'Remote working request',
        updatePersonalDetails: 'Update personal details',
        updateEmailSubscriptions: 'Update my emails subscriptions',
        delete: 'Delete',
        meetingsOptin: 'Update my meetings',
        newsletterOptin: 'Update my emails subscriptions',
        sendEmail: 'Send an email',
        openMap: 'Open map',
        attendevent: 'I will attend',
        attendInPerson: 'In person',
        attendOnline: 'Online',
        attendViaPhone: 'I will attend via phone',
        apologies: 'Apologies',
        attendingDiner: 'Attending dinner?',
        attendDiner: "I'm coming for dinner",
        notAttendDiner: "I'm not coming for dinner",
        cookieConsent: 'Agree'
      },
      cookieBar: {
        title: 'This website uses cookies',
        description: 'This website uses cookies to improve your experience on this site. Some of the cookies we use are essential for parts of the site to operate. To find out more about cookies on this website and how to delete cookies, see our cookies policy To find out more about the cookies we use and how to delete them, see our privacy policy.',
        label: 'I accept cookies from this website'
      },
      documents: {
        annexes: 'Annexes'
      },
      tools: {
        results: 'result(s)'
      },
      at: 'at'
    },
    login: {
      gdpr: 'CropLife and its Members adhere to the principles of the General Data Protection Regulation (GDPR). Parties agree that personal data is obtained for specified, explicit and legitimate purposes and not further processed in a manner that is incompatible with those purposes. They agree that data processed is adequate, relevant and limited to what is necessary, accurate and, where necessary, kept up to date. They agree that personal data is not kept longer than is necessary but data, e.g. aggregated for archiving and research purposes can be kept longer, always subject to safeguards. By accessing the extranet you confirm and abide by these GDPR principles. Members can update their contact info on the site itself. If you no longer wish your details to be included on the extranet please contact info@croplifeeurope.eu'
    },
    modal: {
      request: {
        startDate: 'Start date',
        endDate: 'End date',
        choose: 'Choose',
        morning: 'Morning',
        afternoon: 'Afternoon',
        comment: 'Comment',
        users: 'Other CropLife staff attending',
        destination: 'Destination',
        location: 'Location',
        purpose: 'Purpose of travel',
        submit: 'Send request',
        or: 'or',
        cancel: 'Cancel'
      },
      help: {
        title: 'Help'
      },
      sendEmail: {
        separator: 'Change email separator',
        sendTo: 'To:',
        sendCc: 'Cc:',
        sendToBtn: 'Copy To contacts to clipboard',
        sendCcBtn: 'Copy Cc contacts to clipboard'
      }
    },
    home: {
      spotlight: {
        tweetsTitle: 'Tweets'
      },
      documents: {
        button: {
          text: 'View all documents',
          route: '/documents'
        }
      },
      events: {
        button: {
          text: 'View all',
          route: '/calendar'
        }
      }
    },
    contact: {
      table: {
        heading: {
          selectAll: 'Select all contacts',
          basicInfo: 'Last name / First name / Function',
          groupsRoles: 'Expert groups / Roles',
          company: 'Company',
          phone: 'Phone',
          email: 'E-mail',
          expertGroups: 'Expert groups',
          role: 'Role'
        }
      },
      list: {
        button: {
          more: {
            text: 'View more contacts'
          }
        }
      }
    },
    filters: {
      labels: {
        all: 'All'
      },
      search: {
        placeholder: 'Search...',
        reset: 'Reset'
      },
      categories: [
        {
          text: 'All the site',
          value: 'all'
        },
        {
          text: 'Documents',
          value: 'documents'
        },
        {
          text: 'CropLife Europe Meetings',
          value: 'meetings'
        },
        {
          text: 'Contacts',
          value: 'users'
        },
        {
          text: 'Groups & Teams',
          value: 'groups'
        },
        {
          text: 'Pages',
          value: 'pages'
        }
      ],
      buttons: {
        update: {
          text: 'Update results'
        },
        reset: {
          text: 'Reset'
        }
      }
    },
    sidebar: {
      stewardship: {
        button: {
          text: 'Training documents',
          route: '/documents/list?filters=subtopic-146,subtopic-170'
        }
      },
      documents: {
        button: {
          text: 'View all',
          route: '/documents/list'
        }
      },
      events: {
        button: {
          text: 'View all',
          route: '/calendar/calendar-view'
        }
      },
      workgroups: {
        button: {
          text: 'View all',
          route: '/contacts/groups-teams'
        }
      },
      holidays: {
        labels: {
          from: 'From',
          till: 'Till',
          days: '# of days',
          status: 'Status',
          comment: 'Comment'
        },
        button: {
          text: 'View all',
          route: '/my-holidays'
        }
      },
      travels: {
        labels: {
          destination: 'Destination',
          purpose: 'Purpose',
          other: 'Other staff',
          from: 'From',
          dateDeparture: 'From',
          till: 'Till',
          dateReturn: 'Till',
          status: 'Status',
          comment: 'Comment'
        },
        button: {
          text: 'View all',
          route: '/my-travels'
        }
      },
      remoteWorking: {
        labels: {
          location: 'Location',
          from: 'From',
          till: 'Till',
          status: 'Status'
        },
        button: {
          text: 'View all',
          route: '/my-remote-working'
        }
      }
    },
    profile: {
      admin: 'mailto:bianca.madularescu@croplifeeurope.eu',
      adminContact: 'Contact CropLife to change your details',

      selectSections: 'Select sections from witch you receive automatic update email notification',
      selectEvents: 'Select events from witch you receive automatic update email notification',
      newsletterOptinMessage: 'I want to receive the following newsletters from CropLife',

      personal: {
        title: 'Personal details',
        general: {
          title: 'GENERAL',
          fields: {
            title: {
              label: 'Title',
              options: ['None', 'Miss', 'Ms', 'Mr', 'Commissioner', 'Dr', 'H.E.', 'Ing', 'Ir', 'Prof', 'S.E.', 'San', 'Sr.', 'Sra.', 'Vice-President', 'President']
            },
            lastname: {
              label: 'Last name'
            },
            firstname: {
              label: 'First name'
            },
            middlename: {
              label: 'Middle Name'
            },
            picture: {
              label: 'Profile picture'
            }
          }
        },
        company: {
          title: 'COMPANY',
          fields: {
            company: {
              label: 'Company'
            },
            department: {
              label: 'Department'
            },
            job: {
              label: 'Function'
            }
          }
        },
        contact: {
          title: 'PHONE / E-MAIL / ONLINE',
          fields: {
            phone: {
              label: 'Phone'
            },
            mobilePhone: {
              label: 'Mobile Phone'
            },
            fax: {
              label: 'Fax'
            },
            email: {
              label: 'E-mail'
            },
            facebook: {
              label: 'Facebook URL'
            },
            linkedin: {
              label: 'Linkedin URL'
            },
            twitter: {
              label: 'Twitter URL'
            }
          }
        },
        password: {
          title: 'PASSWORD',
          fields: {
            password: {
              label: 'New password'
            },
            passwordConfirmation: {
              label: 'Re-type new password'
            }
          }
        },
        mailing: {
          title: 'COMPANY ADDRESS',
          fields: {
            streetname: {
              label: 'Street name'
            },
            number: {
              label: 'Number'
            },
            box: {
              label: 'Box'
            },
            city: {
              label: 'City'
            },
            zip: {
              label: 'Zip code'
            },
            country: {
              label: 'Country'
            }
          }
        },
        street: {
          title: 'PRIVATE ADDRESS',
          fields: {
            sameAddress: {
              label: 'Same as the company address'
            },
            streetname: {
              label: 'Street name'
            },
            number: {
              label: 'Number'
            },
            box: {
              label: 'Box'
            },
            city: {
              label: 'City'
            },
            zip: {
              label: 'Zip code'
            },
            country: {
              label: 'Country'
            }
          }
        },
        assistant: {
          title: 'ASSISTANT',
          fields: {
            name: {
              label: 'Assistant Name'
            },
            email: {
              label: 'Assistant E-mail'
            },
            phone: {
              label: 'Assistant Phone'
            },
            fax: {
              label: 'Assistant Fax'
            }
          }
        },
        special: {
          title: 'SPECIAL REQUIREMENTS',
          fields: {
            dietary: {
              label: 'Dietary'
            }
          }
        }
      },

      subscriptions: {
        title: 'My email subscriptions',
        notifications: {
          title: 'MY NOTIFICATION SETTINGS',
          documents: {
            title: 'Documents',
            description: 'Select sections from wich you will receive automatic update email notification.'
          },
          events: {
            title: 'Events',
            description: 'Select events from wich you will receive automatic update email notification.'
          },
          fields: {
            frequency: {
              label: 'Please send me information updates',
              options: [
                'None',
                'Daily',
                'Weekly',
                'Monthly'
              ]
            },
            croplifeEvents: {
              label: 'CropLife Europe Events'
            },
            externalEvents: {
              label: 'External Events'
            }
          }
        },
        newsletter: {
          title: 'MY NEWSLETTERS',
          description: 'I want to receive the following newsletters from CropLife Europe',
          fields: {
            pesticide: {
              label: 'With or without pesticide'
            }
          }
        }
      },
      labels: {
        userGroup: ['Administrators', 'Staff', 'CropLife Admin'],
        frequency: 'Please send me information updates',
        'croplife-events': 'CropLife events',
        'external-events': 'External events'
      }
    },
    users: {
      company: {
        title: 'Company',
        name: 'Name',
        function: 'Function',
        department: 'Department'
      },
      address: {
        title: 'Address',
        mailingAddress: 'Company Address',
        mailingAddressBox: 'Company Box',
        mailingAddressCity: 'Company City',
        mailingAddressZip: 'Company Zip',
        mailingAddressCountry: 'Company Country'
      },
      telephone: {
        title: 'Telephone - Email - Online',
        phone: 'Telephone',
        fax: 'Fax',
        mobile: 'Mobile',
        email: 'Email',
        online: 'Online'
      },
      assistant: {
        title: 'Assistant',
        name: 'Name',
        telephone: 'Telephone',
        fax: 'Fax',
        email: 'Email'
      },
      belongToGroup: {
        title: 'Belong to group(s)',
        groups: 'Expert groups',
        role: 'Role'
      }
    },
    holidays: {
      entitlement: {
        title: 'Entitlement',
        year: 'Year',
        remainderPreviousYear: 'Remainder previous year',
        entitlementCurrentYear: 'Entitlement current year',
        compensationDays: 'Compensation days',
        recuperationDays: 'Recuperation days',
        extraEntitlement: 'Extra entitlement',
        extraEntitlementDetail: ' - 4 days (20 years service)',
        totalEntitlement: 'Total entitlement',
        alreadyTaken: 'Already taken in current year',
        remainderCurrent: 'Remainder current year',
        additionalDays: 'Additional Days'
      },
      overview: {
        title: 'Overview',
        from: 'From',
        till: 'Till',
        days: '# of days',
        status: 'Status'
      },
      request: {
        title: 'Holiday Request'
      }
    },
    travels: {
      overview: {
        title: 'Overview',
        destination: 'Destination',
        purpose: 'Purpose of travel',
        other: 'Other CropLife staff attending',
        dateDeparture: 'Date of departure',
        dateReturn: 'Date of return',
        status: 'Status'
      },
      request: {
        title: 'Travel Request'
      }
    },
    remoteWorking: {
      overview: {
        title: 'Overview',
        location: 'Location',
        from: 'From',
        till: 'Till',
        status: 'Status'
      },
      request: {
        title: 'Remote Working Request'
      }
    },
    calendar: {
      legend: 'Legend',
      'public-holidays': 'Public holidays',
      'travels': 'Travels',
      'holidays-absence': 'Holidays, absence',
      'croplife-group-meeting': 'CropLife group meeting',
      'croplife-events': 'CropLife Events',
      'external-events': 'External Events',
      'meeting': 'Meeting',
      'homeworking': 'Homeworking'
    },
    document: {
      button: {
        more: {
          text: 'View more documents'
        }
      }
    },
    search: {
      noresults: 'There is no results',
      documents: {
        button: {
          text: 'View more documents'
        }
      },
      pastEvents: {
        button: {
          text: 'View more Past Meetings'
        }
      },
      upcomingEvents: {
        button: {
          text: 'View more Upcoming Meetings'
        }
      },
      users: {
        button: {
          text: 'View more contacts'
        }
      },
      groups: {
        button: {
          text: 'View more groups'
        }
      },
      pages: {
        button: {
          text: 'View more pages'
        }
      }
    },
    months: [
      {
        name: 'January',
        abbr: 'Jan'
      },
      {
        name: 'February',
        abbr: 'Feb'
      },
      {
        name: 'March',
        abbr: 'Mar'
      },
      {
        name: 'April',
        abbr: 'Apr'
      },
      {
        name: 'May',
        abbr: 'May'
      },
      {
        name: 'June',
        abbr: 'Jun'
      },
      {
        name: 'July',
        abbr: 'Jul'
      },
      {
        name: 'August',
        abbr: 'Aug'
      },
      {
        name: 'September',
        abbr: 'Sep'
      },
      {
        name: 'October',
        abbr: 'Oct'
      },
      {
        name: 'November',
        abbr: 'Nov'
      },
      {
        name: 'December',
        abbr: 'Dec'
      }
    ],
    countries: [
      'None',
      'Afghanistan',
      'Åland Islands',
      'Albania',
      'Algeria',
      'American Samoa',
      'Andorra',
      'Angola',
      'Anguilla',
      'Antarctica',
      'Antigua and Barbuda',
      'Argentina',
      'Armenia',
      'Aruba',
      'Australia',
      'Austria',
      'Azerbaijan',
      'Bahamas',
      'Bahrain',
      'Bangladesh',
      'Barbados',
      'Belarus',
      'Belgium',
      'Belize',
      'Benin',
      'Bermuda',
      'Bhutan',
      'Bolivia',
      'Bosnia and Herzegovina',
      'Botswana',
      'Bouvet Island',
      'Brazil',
      'British Indian Ocean Territory',
      'Brunei Darussalam',
      'Bulgaria',
      'Burkina Faso',
      'Burundi',
      'Cambodia',
      'Cameroon',
      'Canada',
      'Cape Verde',
      'Cayman Islands',
      'Central African Republic',
      'Chad',
      'Chile',
      'China',
      'Christmas Island',
      'Cocos (Keeling) Islands',
      'Colombia',
      'Comoros',
      'Congo',
      'Congo, The Democratic Republic of the',
      'Cook Islands',
      'Costa Rica',
      'Cote D\'Ivoire',
      'Croatia',
      'Cuba',
      'Cyprus',
      'Czech Republic',
      'Denmark',
      'Djibouti',
      'Dominica',
      'Dominican Republic',
      'Ecuador',
      'Egypt',
      'El Salvador',
      'Equatorial Guinea',
      'Eritrea',
      'Estonia',
      'Ethiopia',
      'Falkland Islands (Malvinas)',
      'Faroe Islands',
      'Fiji',
      'Finland',
      'France',
      'French Guiana',
      'French Polynesia',
      'French Southern Territories',
      'Gabon',
      'Gambia',
      'Georgia',
      'Germany',
      'Ghana',
      'Gibraltar',
      'Greece',
      'Greenland',
      'Grenada',
      'Guadeloupe',
      'Guam',
      'Guatemala',
      'Guernsey',
      'Guinea',
      'Guinea-Bissau',
      'Guyana',
      'Haiti',
      'Heard Island and Mcdonald Islands',
      'Holy See (Vatican City State)',
      'Honduras',
      'Hong Kong',
      'Hungary',
      'Iceland',
      'India',
      'Indonesia',
      'Iran, Islamic Republic Of',
      'Iraq',
      'Ireland',
      'Isle of Man',
      'Israel',
      'Italy',
      'Jamaica',
      'Japan',
      'Jersey',
      'Jordan',
      'Kazakhstan',
      'Kenya',
      'Kiribati',
      'Korea, Democratic People\'S Republic of',
      'Korea, Republic of',
      'Kuwait',
      'Kyrgyzstan',
      'Lao People\'S Democratic Republic',
      'Latvia',
      'Lebanon',
      'Lesotho',
      'Liberia',
      'Libyan Arab Jamahiriya',
      'Liechtenstein',
      'Lithuania',
      'Luxembourg',
      'Macao',
      'Macedonia, The Former Yugoslav Republic of',
      'Madagascar',
      'Malawi',
      'Malaysia',
      'Maldives',
      'Mali',
      'Malta',
      'Marshall Islands',
      'Martinique',
      'Mauritania',
      'Mauritius',
      'Mayotte',
      'Mexico',
      'Micronesia, Federated States of',
      'Moldova, Republic of',
      'Monaco',
      'Mongolia',
      'Montserrat',
      'Morocco',
      'Mozambique',
      'Myanmar',
      'Namibia',
      'Nauru',
      'Nepal',
      'Netherlands',
      'Netherlands Antilles',
      'New Caledonia',
      'New Zealand',
      'Nicaragua',
      'Niger',
      'Nigeria',
      'Niue',
      'Norfolk Island',
      'Northern Mariana Islands',
      'Norway',
      'Oman',
      'Pakistan',
      'Palau',
      'Palestinian Territory, Occupied',
      'Panama',
      'Papua New Guinea',
      'Paraguay',
      'Peru',
      'Philippines',
      'Pitcairn',
      'Poland',
      'Portugal',
      'Puerto Rico',
      'Qatar',
      'Reunion',
      'Romania',
      'Russian Federation',
      'RWANDA',
      'Saint Helena',
      'Saint Kitts and Nevis',
      'Saint Lucia',
      'Saint Pierre and Miquelon',
      'Saint Vincent and the Grenadines',
      'Samoa',
      'San Marino',
      'Sao Tome and Principe',
      'Saudi Arabia',
      'Senegal',
      'Serbia and Montenegro',
      'Seychelles',
      'Sierra Leone',
      'Singapore',
      'Slovakia',
      'Slovenia',
      'Solomon Islands',
      'Somalia',
      'South Africa',
      'South Georgia and the South Sandwich Islands',
      'Spain',
      'Sri Lanka',
      'Sudan',
      'Suriname',
      'Svalbard and Jan Mayen',
      'Swaziland',
      'Sweden',
      'Switzerland',
      'Syrian Arab Republic',
      'Taiwan, Province of China',
      'Tajikistan',
      'Tanzania, United Republic of',
      'Thailand',
      'Timor-Leste',
      'Togo',
      'Tokelau',
      'Tonga',
      'Trinidad and Tobago',
      'Tunisia',
      'Turkey',
      'Turkmenistan',
      'Turks and Caicos Islands',
      'Tuvalu',
      'Uganda',
      'Ukraine',
      'United Arab Emirates',
      'United Kingdom',
      'United States',
      'United States Minor Outlying Islands',
      'Uruguay',
      'Uzbekistan',
      'Vanuatu',
      'Venezuela',
      'Viet Nam',
      'Virgin Islands, British',
      'Virgin Islands, U.S.',
      'Wallis and Futuna',
      'Western Sahara',
      'Yemen',
      'Zambia',
      'Zimbabwe'
    ]
  }
}
